<template>
  <div class="app-container">
    <el-form
      :model="queryParams"
      ref="queryForm"
      size="small"
      :inline="true"
      v-show="showSearch"
    >
      <el-form-item label="菜单名称" prop="name">
        <el-input
          v-model="queryParams.name"
          placeholder="请输入菜单名称"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select
          v-model="queryParams.status"
          placeholder="菜单状态"
          clearable
        >
          <el-option
            v-for="dict in options"
            :key="dict.value"
            :label="dict.label"
            :value="dict.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          icon="el-icon-search"
          size="mini"
          @click="handleQuery"
          >搜索</el-button
        >
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery"
          >重置</el-button
        >
      </el-form-item>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button
          type="primary"
          plain
          icon="el-icon-plus"
          size="mini"
          @click="handleAdd"
          >新增</el-button
        >
      </el-col>
      <el-col :span="1.5">
        <el-button
          type="info"
          plain
          icon="el-icon-sort"
          size="mini"
          @click="toggleExpandAll"
          >展开/折叠</el-button
        >
      </el-col>
      <right-toolbar
        :showSearch.sync="showSearch"
        @queryTable="getList"
      ></right-toolbar>
    </el-row>

    <el-table
      v-if="refreshTable"
      v-loading="loading"
      :data="menuList"
      row-key="id"
      height="calc(100vh - 200px)"
      :default-expand-all="isExpandAll"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
    >
      <el-table-column
        prop="name"
        label="菜单名称"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column prop="iconcls" label="图标" align="center">
        <template slot-scope="scope">
          <i :class="scope.row.iconcls"></i>
        </template>
      </el-table-column>
      <!--  <el-table-column prop="sort" label="排序" width="60"></el-table-column>
      <el-table-column
        prop="perCode"
        label="权限标识"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
        prop="path2"
        label="组件路径"
        :show-overflow-tooltip="true"
      ></el-table-column> -->
      <el-table-column prop="isValid" label="状态">
        <template slot-scope="scope">
          <!-- <dict-tag :options="options" :value="scope.row.status" /> -->
          <el-tag v-if="scope.row.isValid == 1">正常</el-tag>
          <el-tag type="danger" v-if="scope.row.isValid == 2">停用</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" align="center" prop="createTime" min-width="130" :formatter="dateTimeTwoLine" class-name="cell-two-line">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            icon="el-icon-edit"
            @click="handleUpdate(scope.row)"
            >修改</el-button
          >
          <!-- <el-button
            size="mini"
            type="text"
            icon="el-icon-plus"
            @click="handleAdd(scope.row)"
            >新增</el-button
          > -->
          <!-- <el-button
            size="mini"
            type="text"
            icon="el-icon-delete"
            @click="handleDelete(scope.row)"
            >删除</el-button
          > -->
        </template>
      </el-table-column>
    </el-table>

    <!-- 添加或修改菜单对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="680px" append-to-body       :close-on-click-modal="false"
      :close-on-press-escape="false"
>
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="上级菜单" prop="parentId">
              <treeselect
                v-model="form.parentId"
                :options="menuOptions"
                :normalizer="normalizer"
                :show-count="true"
                placeholder="选择上级菜单"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="菜单图标" prop="iconcls">
              <el-popover
                placement="bottom-start"
                :width="420"
                trigger="click"
                @show="$refs['iconSelect'] && $refs['iconSelect'].reset()"
              >
                <IconSelect
                  ref="iconSelect"
                  :active-icon="form.iconcls"
                  @selected="selected"
                />
                <el-input
                  slot="reference"
                  v-model="form.iconcls"
                  placeholder="点击选择图标"
                  readonly
                >
                  <template slot="prefix" v-if="form.iconcls">
                    <i :class="form.iconcls" style="line-height: 40px; padding-left: 6px; font-size: 16px;"></i>
                  </template>
                </el-input>
              </el-popover>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="菜单名称" prop="title">
              <el-input v-model="form.title" placeholder="请输入菜单名称" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="菜单模块" prop="component">
              <span slot="label">
                <el-tooltip
                  content="主菜单填Home，子菜单填文件前置，如：PlatStaff"
                  placement="top"
                >
                  <i class="el-icon-question"></i>
                </el-tooltip>
                菜单模块
              </span>
              <el-input v-model="form.component" placeholder="菜单模块" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="path2">
              <span slot="label">
                <el-tooltip content="如：/plat/menu" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
                路由地址
              </span>
              <el-input v-model="form.path2" placeholder="请输入路由地址" />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item prop="isValid">
              <span slot="label">
                <el-tooltip
                  content="选择停用则路由将不会出现在侧边栏，也不能被访问"
                  placement="top"
                >
                  <i class="el-icon-question"></i>
                </el-tooltip>
                菜单状态
              </span>
              <el-radio-group v-model="form.isValid">
                <el-radio
                  v-for="dict in statusOptions"
                  :key="dict.value"
                  :label="dict.value"
                  >{{ dict.label }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getselectMenuListAndChildrenByParam,
  postTbMenuInsertAdd,
  postTbMenuUpdate,
  postTbMenuDelete,
  getTbMenuIDdep,
  selectMenuListByParam,
} from "@/api/plat/PlatMenu";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import IconSelect from "@/components/IconSelect";
import { EventBus } from "@/utils/event-bus.js";
export default {
  name: "Menu",
  // dicts: ["sys_show_hide", "sys_normal_disable"],
  components: { Treeselect, IconSelect },
  data() {
    return {
      statusOptions: [
        {
          value: 1,
          label: "启用",
        },
        {
          value: 2,
          label: "停用",
        },
      ],
      options: [
        {
          value: 1,
          label: "显示",
        },
        {
          value: 0,
          label: "隐藏",
        },
      ],

      // 遮罩层
      loading: true,
      // 显示搜索条件
      showSearch: true,
      // 菜单表格树数据
      menuList: [],
      // 菜单树选项
      menuOptions: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 是否展开，默认全部折叠
      isExpandAll: false,
      // 重新渲染表格状态
      refreshTable: true,
      // 查询参数
      queryParams: {
        title: "",
      },
      menuVO: {},
      // 表单参数
      form: {
        title: "",
        parentId: "",
        isValid: "",
        path2: "/home",
        component: "",
        iconcls: "",
      },
      // 表单校验
      rules: {
        title: [
          { required: true, message: "菜单名称不能为空", trigger: "blur" },
        ],
        component: [
          { required: true, message: "菜单模块不能为空", trigger: "blur" },
        ],
        path: [
          { required: true, message: "路由地址不能为空", trigger: "blur" },
        ],
        parentId: [
          { required: true, message: "主菜单不能为空", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 选择图标
    selected(name) {
      this.form.iconcls = name;
    },
    /** 查询菜单列表 */
    async getList() {
      this.loading = true;
      let { data } = await getselectMenuListAndChildrenByParam(
        this.queryParams
      );
      this.menuList = data;
      this.loading = false;
    },
    /** 转换菜单数据结构 */
    normalizer(node) {
      if (node.children && !node.children.length) {
        delete node.children;
      }
      return {
        id: node.id,
        label: node.title,
        children: node.children,
      };
    },
    /** 查询菜单下拉树结构 */
    getTreeselect() {
      this.menuOptions = [];
      const menu = { id: -1, title: "主类目", children: [] };
      menu.children = this.menuList;
      this.menuOptions.push(menu);
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        title: "",
        parentId: "",
        isValid: "",
        path2: "",
        component: "",
        iconcls: "",
      };
    },
    /** 搜索按钮操作 */
    handleQuery() {
      selectMenuListByParam(this.queryParams).then((response) => {
        this.menuList = response.data;
        this.loading = false;
      });
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParams.title = "";
      this.getList();
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset();
      this.getTreeselect();
      if (row != null && row.menuId) {
        this.form.parentId = row.menuId;
      } else {
        this.form.parentId = -1;
        this.form.grade = 0;
      }
      this.open = true;
      this.title = "添加菜单";
    },
    /** 展开/折叠操作 */
    toggleExpandAll() {
      this.refreshTable = false;
      this.isExpandAll = !this.isExpandAll;
      this.$nextTick(() => {
        this.refreshTable = true;
      });
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      this.getTreeselect();
      this.form = row;
      this.open = true;
      this.title = "修改菜单";
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (this.form.id != undefined) {
            this.form.iconcls = "fa fa-" + this.form.iconcls;
            postTbMenuUpdate(this.form).then((response) => {
              this.$message.success("修改成功");

              debugger;
              this.open = false;
              this.getList();
              EventBus.$emit("refresh-menu"); // <- 广播刷新菜单事件
            });
          } else {
            postTbMenuInsertAdd(this.form).then((response) => {
              this.$message.success("新增成功");
              this.open = false;
              this.getList();
              EventBus.$emit("refresh-menu"); // <- 广播刷新菜单事件
            });
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      this.$modal
        .confirm('是否确认删除名称为"' + row.name + '"的数据项？')
        .then(function () {
          return postTbMenuDelete([row.id]);
        })
        .then(() => {
          this.getList();
          this.$message.success("删除成功");
        })
        .catch(() => {});
    },
  },
};
</script>
